import { Col, Row } from "antd";
import React from "react";
import { useLocation, useNavigate } from "react-router";
import styled from "styled-components";
import qs from "qs";
import { theme } from "../../../theme";
import { ReactComponent as WestArrow } from "../../../assets/icons/WestArrow.svg";
import { speedMateCodeString } from "../../../routes/constants/path";
import { ReactComponent as RightArrow } from "../../../assets/icons/ArrowRight.svg";

export interface DynamicRoutingProps {
  smallMenu?: string;
  menu?: string;
  navTarget?: string;
  defaultQuery?: string;
}

const DynamicRoutingLayout: React.FC<DynamicRoutingProps> = (props) => {
  const {
    smallMenu = "",
    menu = "",
    children,
    navTarget = "/",
    defaultQuery,
  } = props;

  const { pathname, search } = useLocation();
  const splitPathname = pathname.split("/");
  const id = pathname.split("/")[splitPathname.length - 1];

  const query = qs.parse(search);
  (query[defaultQuery || speedMateCodeString] as string | undefined) =
    undefined;

  const nav = useNavigate();
  return (
    <Row>
      <Col span={24}>
        <Row align="top">
          <Col>
            <StyledMenu>{menu.split(">")[0]}</StyledMenu>
          </Col>
          <Col style={{ paddingTop: "4px" }}>
            <RightArrow />
          </Col>
          <Col>
            <StyledMenu>{menu.split(">")[1]}</StyledMenu>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row
          onClick={() => nav(`${navTarget}${defaultQuery ? search : search}`)}
          style={{ cursor: "pointer" }}
        >
          <WestArrow />
          <StyledSmallMenu>{`${smallMenu}(${id})`}</StyledSmallMenu>
        </Row>
      </Col>
      <Col span={24} style={{ paddingTop: 24 }}>
        {children}
      </Col>
    </Row>
  );
};

const StyledMenu = styled.div`
  ${theme.typo.body.r16};
`;

const StyledSmallMenu = styled.div`
  ${theme.typo.title.t32};
`;

export default DynamicRoutingLayout;
